import type { ChatScope } from "@/lib/api/agent";
import type { PerspectiveId } from "@/lib/perspectives";

// Every chat entry point (hero CTA, /chat) derives the same scope from the inventory
// ScopeBar — building wins over group, with an inventory (kiinteistökanta) fallback.
// Kept in one place so chat entry points never drift apart on how scope is resolved.
// /reports is a deterministic template artifact and does not use chat scope.
// `lens` is omitted by the sidebar/general entry (/chat) — only the perspective hero
// CTA passes its own perspective id, so that entry alone reaches a lens specialist.
export function inventoryChatScope(
  buildingId: string | null,
  groupId: string | null,
  lens?: PerspectiveId,
): ChatScope {
  if (buildingId) return { level: "building", context_id: buildingId, lens };
  if (groupId) return { level: "group", context_id: groupId, lens };
  return { level: "inventory", lens };
}
